import { c as _c } from "react/compiler-runtime";
import { IcoWarning16 } from '@onefootprint/icons';
import { Dropdown } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { useNavModel } from '../../hooks/use-nav-model';
import type { Issue } from '../../hooks/use-validation-summary';
import useIssueCountsLabel from './use-issue-counts-label';
type IssuesBadgeProps = {
  issues: Issue[];
  onSelect: (issue: Issue) => void;
  defaultOpen?: boolean;
};
const IssuesBadge = t0 => {
  const $ = _c(25);
  const {
    issues,
    onSelect,
    defaultOpen
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  const {
    planEntries
  } = useNavModel(false);
  const errors = issues.filter(_temp);
  const warnings = issues.filter(_temp2);
  const label = useIssueCountsLabel(errors.length, warnings.length);
  const groups = [{
    title: useIssueCountsLabel(errors.length, 0),
    issues: errors
  }, {
    title: useIssueCountsLabel(0, warnings.length),
    issues: warnings
  }].filter(_temp3);
  const sectionName = nodeId => planEntries.find(t2 => {
    const {
      row
    } = t2;
    return (row.contextNodeId ?? row.id) === nodeId;
  })?.row.label;
  const t3 = Dropdown;
  let t4;
  if ($[1] !== label || $[2] !== t) {
    t4 = t(_temp4, {
      label
    });
    $[1] = label;
    $[2] = t;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IcoWarning16 color="warning" />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== issues.length) {
    t6 = <span className="md:hidden">{issues.length}</span>;
    $[5] = issues.length;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== label) {
    t7 = <span className="hidden md:inline">{label}</span>;
    $[7] = label;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t4 || $[10] !== t6 || $[11] !== t7) {
    t8 = <Dropdown.Trigger asChild={true}><button type="button" className="flex items-center gap-1 px-2 h-7 rounded text-caption-2 font-medium bg-warning text-warning hover:opacity-80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-warning transition-opacity" aria-label={t4}>{t5}{t6}{t7}</button></Dropdown.Trigger>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = Dropdown;
  const t10 = Dropdown;
  const t11 = "end";
  const t12 = 16;
  const t13 = "w-80 max-h-[min(400px,var(--radix-dropdown-menu-content-available-height))] overflow-y-auto p-1";
  const t14 = _temp5;
  const t15 = groups.map(group_0 => <Dropdown.Group key={group_0.title}><Dropdown.GroupTitle className="px-2 py-1 text-label-3 text-tertiary">{group_0.title}</Dropdown.GroupTitle>{group_0.issues.map((issue_1, index) => {
      const {
        keyError
      } = issue_1;
      return <Dropdown.Item key={index} className="h-auto! px-2! py-1.5!" onSelect={() => onSelect(issue_1)}><span className="flex min-w-0 flex-col gap-0.5"><span className="truncate text-caption-2 text-tertiary">{sectionName(issue_1.nodeId)}</span><span className="line-clamp-2 whitespace-normal text-body-3">{issue_1.key && <code className="mr-1 text-snippet-2">{issue_1.key}</code>}{keyError ? t($_0 => $_0.fieldKey.errors[keyError]) : issue_1.message}</span></span></Dropdown.Item>;
    })}</Dropdown.Group>);
  let t16;
  if ($[13] !== t10.Content || $[14] !== t14 || $[15] !== t15) {
    t16 = <t10.Content align={t11} collisionPadding={t12} className={t13} onCloseAutoFocus={t14}>{t15}</t10.Content>;
    $[13] = t10.Content;
    $[14] = t14;
    $[15] = t15;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] !== t16 || $[18] !== t9.Portal) {
    t17 = <t9.Portal>{t16}</t9.Portal>;
    $[17] = t16;
    $[18] = t9.Portal;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  let t18;
  if ($[20] !== defaultOpen || $[21] !== t17 || $[22] !== t3.Root || $[23] !== t8) {
    t18 = <t3.Root defaultOpen={defaultOpen}>{t8}{t17}</t3.Root>;
    $[20] = defaultOpen;
    $[21] = t17;
    $[22] = t3.Root;
    $[23] = t8;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  return t18;
};
export default IssuesBadge;
function _temp(issue) {
  return issue.severity === "error";
}
function _temp2(issue_0) {
  return issue_0.severity === "warning";
}
function _temp3(group) {
  return group.issues.length > 0;
}
function _temp4($) {
  return $.validations.showAria;
}
function _temp5(event) {
  if (document.activeElement && document.activeElement !== document.body) {
    event.preventDefault();
  }
}